<script setup>
import Footer from '@/layouts/partials/Footer.vue'
import Navbar from '@/layouts/partials/Navbar.vue'
</script>

<template>
    <div class="flex min-h-screen flex-col justify-between">
        <a
            class="bg-brand-900 sr-only z-[60] rounded-md px-4 py-2 text-sm font-extrabold tracking-wider text-white uppercase focus:not-sr-only focus:fixed focus:top-4 focus:left-4"
            href="#main"
        >
            Přeskočit na obsah
        </a>

        <Navbar />

        <main id="main">
            <slot />
        </main>

        <Footer />
    </div>
</template>
